import { dataModelTypeOptions } from "./dataModelValidators";

/** The list's Type cell: the type's name rather than the number stored for it. */
export function DataModelTypeLabel({ value }: { value: unknown }) {
  const option = dataModelTypeOptions.find(
    (candidate) => String(candidate.Key) === String(value)
  );

  return <>{option?.Value ?? ""}</>;
}
